import { yupResolver } from "@hookform/resolvers/yup";
import { ApiVaultKeyFormValues } from "./types";
import { defaultFormValues, schema } from "./constants";
import { FormProvider, useForm } from "react-hook-form";

export interface ApiVaultKeyFormProviderProps {
  children?: React.ReactNode;
}

export const ApiVaultKeyFormProvider = ({
  children,
}: ApiVaultKeyFormProviderProps) => {
  const methods = useForm<ApiVaultKeyFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
